export default {
  appName: 'KeyzoStore',

  // Generic actions
  actions: {
    addToCart: 'Přidat do košíku',
    buyNow: 'Koupit ihned',
    save: 'Uložit',
    saveChanges: 'Uložit změny',
    cancel: 'Zrušit',
    confirm: 'Potvrdit',
    continue: 'Pokračovat',
    back: 'Zpět',
    close: 'Zavřít',
    search: 'Hledat',
    loadMore: 'Načíst další',
    viewAll: 'Zobrazit vše',
    viewDetails: 'Zobrazit detail',
    remove: 'Odebrat',
    edit: 'Upravit',
    delete: 'Smazat',
    apply: 'Použít',
    submit: 'Odeslat',
    retry: 'Zkusit znovu',
    copy: 'Kopírovat',
    copied: 'Zkopírováno',
    signIn: 'Přihlásit se',
    signUp: 'Registrovat se',
    signOut: 'Odhlásit se',
    backToTop: 'Zpět nahoru',
  },

  // Mini cart slide-over (components/cart/MiniCart.vue)
  miniCart: {
    title: 'Váš košík · {count}',
    limit: '{count} z {limit}',
    signedOutTitle: 'Pro použití košíku se přihlaste',
    signedOutBody: 'Přihlaste se, abyste mohli přidávat klíče do košíku a dokončit objednávku.',
    emptyTitle: 'Váš košík je prázdný',
    emptyBody: 'Přidané klíče se zobrazí zde, připravené k objednání.',
    browse: 'Procházet katalog',
    checkout: 'Pokladna',
    decrease: 'Snížit množství položky {name}',
    increase: 'Zvýšit množství položky {name}',
    remove: 'Odebrat {name}',
  },

  // Generic states
  state: {
    loading: 'Načítání…',
    saving: 'Ukládání…',
    error: 'Něco se pokazilo',
    success: 'Hotovo',
    empty: 'Zatím tu nic není',
    noResults: 'Nebyly nalezeny žádné výsledky',
  },

  // Generic labels
  label: {
    price: 'Cena',
    total: 'Celkem',
    subtotal: 'Mezisoučet',
    quantity: 'Množství',
    platform: 'Platforma',
    region: 'Region',
    language: 'Jazyk',
    genre: 'Žánr',
    status: 'Stav',
    date: 'Datum',
    email: 'E-mail',
    password: 'Heslo',
    all: 'Vše',
    yes: 'Ano',
    no: 'Ne',
  },

  // Toasts (stores/toast.ts) — the only notification pattern
  toast: {
    addedToCart: 'Přidáno do košíku',
    viewCart: 'Zobrazit košík',
    cartLimit: 'Košík je plný — {limit} klíčů na objednávku',
    savedToWishlist: 'Uloženo do oblíbených',
    removedFromWishlist: 'Odebráno z oblíbených',
    viewWishlist: 'Zobrazit oblíbené',
    undo: 'Vrátit zpět',
    removedFromCart: 'Odebráno z košíku',
    linkCopied: 'Odkaz zkopírován',
    keyCopied: 'Klíč zkopírován',
  },

  price: {
    from: 'od',
  },

  rail: {
    previous: 'Předchozí',
    next: 'Další',
  },

  breadcrumbs: {
    label: 'Drobečková navigace',
    home: 'Domů',
  },

  // Order / payment status labels (keyed by backend status code)
  orderStatus: {
    CREATED: 'Vytvořeno',
    PAID: 'Zaplaceno',
    PROCESSING: 'Zpracovává se',
    DELIVERED: 'Doručeno',
    COMPLETED: 'Dokončeno',
    FAILED: 'Neúspěšné',
    REFUNDED: 'Vráceno',
  },
};
